import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Sticky = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.4827 41.8023V18.6625C35.4827 17.5082 35.0629 16.5287 34.2234 15.7242C33.3838 14.9196 32.3869 14.5173 31.2325 14.5173H8.19769C7.04333 14.5173 6.05512 14.9283 5.23307 15.7504C4.41102 16.5724 4 17.5606 4 18.715V35.5058L14.4942 46H31.285C32.4394 46 33.4276 45.589 34.2496 44.7669C35.0717 43.9449 35.4827 42.9567 35.4827 41.8023ZM45.9244 12.9432C46.1343 11.7888 45.907 10.7481 45.2423 9.82115C44.5777 8.89416 43.6682 8.32572 42.5138 8.11584L19.7413 4.07556C18.587 3.86567 17.5463 4.09305 16.6193 4.75768C15.6923 5.42232 15.1239 6.33182 14.914 7.48618L14.3893 10.3196H18.6919L19.0592 8.22078L41.7792 12.2611L39.6804 24.1195V38.759C40.2401 38.4442 40.7211 38.0244 41.1233 37.4997C41.5256 36.975 41.7792 36.3803 41.8842 35.7157L45.9244 12.9432ZM31.285 18.715V41.8023H16.5931V33.4069H8.19769V18.715H31.285Z"
        fill={color}
      />
    </svg>
  )
}
